import React, { useEffect, useState } from 'react';
import { Box, Container } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import { useParams } from 'react-router';
import { makeStyles } from '@material-ui/core/styles';
import Page from '../../../components/Layout/Page';
import Header from './Header';
import UsersAssociation from './UsersAssociation';
import storeRequest from '../../../requests/api/store';
import { getUsersPerPage } from '../../../requests/api/users';
import handleApiResponse from '../../../utils/handleApiResponse';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
}));

function StoreUsersView() {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const { id } = useParams();

  const [store, setStore] = useState(null);
  const [users, setUsers] = useState([]);
  const [totalUsers, setTotalUsers] = useState(0);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(5);
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    const getStore = async () => {
      try {
        const response = await storeRequest.getStoreById(id);
        if (response.success) {
          setStore(response.store);
        }
      } catch (err) {
        handleApiResponse(enqueueSnackbar, err, false);
      }
    };
    getStore();
  }, [id]);

  useEffect(() => {
    if (!store) return;
    const getUsers = async () => {
      try {
        const response = await getUsersPerPage(page, limit, searchValue, 'name|ASC', store.clientId, false);
        setUsers(response.users || []);
        setTotalUsers(response.totalUsers || 0);
      } catch (err) {
        handleApiResponse(enqueueSnackbar, err, false);
      }
    };
    getUsers();
  }, [store, page, limit, searchValue]);

  if (!store) return null;

  const assignedUserIds = (store.userStores || [])
    .filter((u) => !u.deleted)
    .map((u) => Number(u.userId));

  return (
    <Page className={classes.root} title="Usuarios del Local">
      <Container maxWidth={false}>
        <Header name={store.name} />
        <Box mt={3}>
          <UsersAssociation
            users={users}
            totalUsers={totalUsers}
            storeId={id}
            initialSelectedUserIds={assignedUserIds}
            page={page}
            limit={limit}
            setPage={setPage}
            setLimit={setLimit}
            setSearchValue={setSearchValue}
          />
        </Box>
      </Container>
    </Page>
  );
}

export default StoreUsersView;
